import React from 'react'
import { Message } from 'semantic-ui-react'
import { NT_CONTACT_PLANNER_LINK, NT_LANDS_AND_PLANNING_LINK } from '../../environment'

import './HistoryDisclaimer.css'

function HistoryDisclaimer() {
  return (
    <div>
      <Message warning>
        <p>You are advised that the information available through this search only covers approvals related
          to the current parcel number and does not show development history relevant to a previous parcel
          number if it has since been subdivided. The development history on this site is provided for
          information only and should not be relied upon for currency or completeness, or in connection
          with any property transaction. Where more detailed and accurate information is required, such
          as for the purpose of conveyancing, development or building certification, it is recommended that you
          <a href={NT_CONTACT_PLANNER_LINK} target="_blank" rel="noopener noreferrer"> contact a planner </a>or
          <a href={NT_LANDS_AND_PLANNING_LINK} target="_blank" rel="noopener noreferrer"> apply for a planning
            certificate</a>.
        </p>
      </Message>
    </div>
  )
}

export default HistoryDisclaimer
